import { Plugin, ChartType } from 'chart.js';

export interface IHoverVerticalLineOptions {
  /**
   * @description Default value is true
   */
  display?: boolean;
  lineColor?: string;
  lineDash?: number[];
  lineWidth?: number;
}

declare module 'chart.js' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface PluginOptionsByType<TType extends ChartType = ChartType> {
    hoverVerticalLine?: IHoverVerticalLineOptions;
  }
}

export const hoverVerticalLinePlugin: Plugin<'line'> = {
  id: 'hoverVerticalLine',

  afterDraw: (chart, _args, options: IHoverVerticalLineOptions) => {
    if (!(options.display ?? true)) {
      return;
    }

    const tooltip = chart.tooltip;

    const activeElements = tooltip?.getActiveElements();

    if (activeElements && activeElements.length > 0) {
      const activePoint = activeElements[0];
      const { ctx } = chart;
      const { x } = activePoint.element;
      const topY = chart.scales['y'].top;
      const bottomY = chart.scales['y'].bottom;

      ctx.save();
      ctx.beginPath();

      ctx.setLineDash(options.lineDash || [5, 5]);
      ctx.lineWidth = options.lineWidth || 1;
      ctx.strokeStyle = options.lineColor || 'black';

      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.stroke();
      ctx.restore();
    }
  },
};
